import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./DiamondVoteResultItem.module.css";
import GreenCheckmark from "ManagementTeam/Shared/GreenCheckmark";
import PendingVoteButton from "ManagementTeam/Shared/PendingVoteButton";
import ThumbsDownButton from "ManagementTeam/Shared/ThumbsDownButton";
import ThumbsUpButton from "ManagementTeam/Shared/ThumbsUpButton";
import ProxyVoteIcon from "ManagementTeam/Shared/ProxyVoteIcon";
import ProxyCheckmark from "ManagementTeam/DashboardPage/ProxyCheckmark";

/**
 * View component. Shows information about the diamond and their voting status
 */

export function DiamondVoteResultItem({ diamondInfo, isHideInfo }) {
  return (
    <div className={styles.container}>
      {diamondInfo.checkedIn || diamondInfo.proxyCheckedIn ? (
        <div className={styles.checkmarkContainer}>
          {diamondInfo.checkedIn && !diamondInfo.proxyCheckedIn && (
            <GreenCheckmark className={styles.checkmark} />
          )}
          {diamondInfo.proxyCheckedIn && (
            <div className={styles.checkMark}>
              <ProxyCheckmark />
            </div>
          )}
          <div className={styles.checkmarkBackground}></div>
        </div>
      ) : null}

      <img
        src={diamondInfo.photo}
        alt={diamondInfo.firstName}
        className={styles.image}
      />
      <div>
        {diamondInfo.firstName} {diamondInfo.lastName}
      </div>
      {!isHideInfo && (
        <div
          className={classNames(
            diamondInfo.isProxyVote === true
              ? styles.resultsContainerProxy
              : styles.resultsContainerNoProxy
          )}
        >
          <div className={styles.votingResult}>
            {diamondInfo.votingStatus === "Yes" ? (
              <ThumbsUpButton isLocked={true} />
            ) : null}
            {diamondInfo.votingStatus === "No" ? (
              <ThumbsDownButton isLocked={true} />
            ) : null}
            {diamondInfo.votingStatus === "Pending" ? (
              <PendingVoteButton isLocked={true} isGrayed={true} />
            ) : null}
          </div>
          <div
            className={classNames(
              diamondInfo.isProxyVote === true ? styles.proxyVote : null
            )}
          >
            {diamondInfo.isProxyVote === true ? <ProxyVoteIcon /> : null}
          </div>
        </div>
      )}
    </div>
  );
}

DiamondVoteResultItem.propTypes = {
  diamondInfo: PropTypes.object,
};
